import client from '@config/client'
import API_URL from '@config/services'
import { ApiClientResult } from '@/types/api'

interface PaymentPayload {
  amount?: number
  payment_date?: string
  payment_method?: string
  notes?: string
  invoice_id?: number | string
  [key: string]: any
}

/**
 * Creates a new payment
 * @param invoiceId - Optional Invoice ID
 * @param payload - Payment data
 * @returns API response
 */
export const onCreatePayment = (
  invoiceId?: number | string,
  payload?: PaymentPayload
): Promise<ApiClientResult> => {
  return client
    .post(
      invoiceId
        ? API_URL.PAYMENTS.POST_PAYMENT(invoiceId)
        : API_URL.PAYMENTS.POST_PAYMENT_PK,
      payload
    )
    .then(response => response)
    .catch(error => {
      return error.response
    })
}

/**
 * Updates a payment
 * @param id - Payment ID
 * @param payload - Payment data to update
 * @returns API response
 */
export const updatePayment = (
  id: number | string,
  payload: Partial<PaymentPayload>
): Promise<ApiClientResult> => {
  return client
    .patch(API_URL.PAYMENTS.PATCH_PAYMENT_PK(id), payload)
    .then(response => response)
    .catch(error => error.response)
}

/**
 * Updates a payment invoice
 * @param id - Payment ID
 * @param payload - Payment data to update
 * @returns API response
 */
export const updatePaymentInvoice = (
  id: number | string,
  payload: Partial<PaymentPayload>
): Promise<ApiClientResult> => {
  return client
    .patch(API_URL.PAYMENTS.PATCH_PAYMENT_INVOIC_EPK(id), payload)
    .then(response => response)
    .catch(error => error.response)
}

/**
 * Deletes a payment
 * @param id - Payment ID
 * @returns API response
 */
export const onDeletePayment = (
  id: number | string
): Promise<ApiClientResult> => {
  return client
    .delete(API_URL.PAYMENTS.DELETE_PAYMENT_PK(id))
    .then(response => response)
    .catch(error => error.response)
}
